export const isSortableCol = (
  key: string,
  sortingValues: Record<string, string>,
) => sortingValues && Object.keys(sortingValues).includes(key);

export const hasSettings = (
  key: string,
  onSettings: Record<string, () => void>,
) => onSettings && Object.keys(onSettings).includes(key);
